import { createRootRoute, Outlet } from '@tanstack/react-router';
import { Toaster } from '@ludolio/shared-ui';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <>
      <Outlet />
      <Toaster richColors position="top-right" />
    </>
  );
}
